import * as React from "react";
const SvgFiRrMapMarkerMinus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-map-marker-minus_svg__a)">
      <path
        fill="#062147"
        d="M8.174 22.454a5.433 5.433 0 0 0 7.578.02l3.984-3.683c4.317-4.258 4.363-11.21.104-15.526C15.583-1.051 8.63-1.098 4.314 3.16l-.104.104c-4.287 4.288-4.286 11.24.001 15.527q.014.012.027.026zM5.62 4.676a8.983 8.983 0 0 1 12.733 12.676l-3.977 3.675a3.51 3.51 0 0 1-4.828-.018l-3.928-3.63a8.983 8.983 0 0 1 0-12.703m1.362 6.352c0-.551.447-.998.998-.998h7.985a.998.998 0 1 1 0 1.996H7.98a1 1 0 0 1-.998-.998"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-map-marker-minus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMapMarkerMinus;
